
<div class="modal-header">
    <h3 class="modal-title">Timeout Warning</h3>
</div>
<div class="modal-body">
    <p>
        You will be logged out in 1 minute.
    </p>
    <p>
        If you are logged off any changes will be lost.
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="refreshClicked()">Stay Logged In</button>
    <button type="button" class="btn btn-default" (click)="logoutClicked()">Logout</button>
</div>
